<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.walletRecords') }}</h1>
    <div class="filter-bar">
      <el-input v-model.trim="search.biz_order_no" :placeholder="$t('walletRecords.bizOrderNo')" class="filter-item"></el-input>
      <el-select v-model="search.wallet_type" clearable :placeholder="$t('walletRecords.walletType')" class="filter-item">
        <el-option v-for="item in walletTypes" :key="item.value" :value="item.value" :label="$t(item.labelKey)"></el-option>
      </el-select>
      <el-select v-model="search.biz_type" clearable :placeholder="$t('walletRecords.bizType')" class="filter-item">
        <el-option v-for="item in businessTypes" :key="item.value" :value="item.value" :label="$t(item.labelKey)"></el-option>
      </el-select>
      <el-select v-model="search.action" clearable :placeholder="$t('walletRecords.action')" class="filter-item">
        <el-option v-for="item in actions" :key="item.value" :value="item.value" :label="$t(item.labelKey)"></el-option>
      </el-select>
      <el-input v-model.trim="search.currency_code" :placeholder="$t('common.currency')" class="filter-item short"></el-input>
      <el-date-picker v-model="search.created_at__gte" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.start')" class="filter-item"></el-date-picker>
      <el-date-picker v-model="search.created_at__lt" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.end')" class="filter-item"></el-date-picker>
      <el-button type="primary" @click="reload">{{ $t('actions.search') }}</el-button>
    </div>

    <div class="table-scroll">
      <el-table :key="tableLanguage" :data="tableData" border stripe>
        <el-table-column prop="biz_order_no" :label="$t('walletRecords.bizOrderNo')" min-width="180"></el-table-column>
        <el-table-column :label="$t('walletRecords.walletType')" min-width="130">
          <template slot-scope="scope">{{ walletTypeText(scope.row.wallet_type) }}</template>
        </el-table-column>
        <el-table-column :label="$t('walletRecords.bizType')" min-width="140">
          <template slot-scope="scope">{{ businessTypeText(scope.row.biz_type) }}</template>
        </el-table-column>
        <el-table-column :label="$t('walletRecords.action')" min-width="160">
          <template slot-scope="scope">{{ actionText(scope.row.action) }}</template>
        </el-table-column>
        <el-table-column prop="currency_code" :label="$t('common.currency')" min-width="90"></el-table-column>
        <el-table-column :label="$t('walletRecords.amount')" min-width="120">
          <template slot-scope="scope"><span :class="amountClass(scope.row.amount_value)">{{ scope.row.amount }}</span></template>
        </el-table-column>
        <el-table-column prop="balance_before" :label="$t('walletRecords.balanceBefore')" min-width="130"></el-table-column>
        <el-table-column prop="balance_after" :label="$t('walletRecords.balanceAfter')" min-width="130"></el-table-column>
        <el-table-column prop="remark" :label="$t('walletRecords.remark')" min-width="160"></el-table-column>
        <el-table-column prop="created_at" :label="$t('common.createdAt')" min-width="165"></el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadData"
    ></el-pagination>
  </section>
</template>

<script>
export default {
  name: 'WalletRecords',
  data() {
    return {
      search: {
        page: 1,
        size: 20,
        biz_order_no: '',
        wallet_type: '',
        biz_type: '',
        action: '',
        currency_code: '',
        created_at__gte: '',
        created_at__lt: ''
      },
      tableData: [],
      count: 0,
      walletTypes: [
        { value: 'topup', labelKey: 'walletTypes.topup' },
        { value: 'earnings', labelKey: 'walletTypes.earnings' }
      ],
      businessTypes: [
        { value: 'EAD', labelKey: 'walletBusinessTypes.ead' },
        { value: 'EAU', labelKey: 'walletBusinessTypes.eau' },
        { value: 'EAW', labelKey: 'walletBusinessTypes.eaw' },
        { value: 'SETTLEMENT', labelKey: 'walletBusinessTypes.settlement' }
      ],
      actions: [
        { value: 'recharge_success', labelKey: 'walletActions.rechargeSuccess' },
        { value: 'topup_deduct', labelKey: 'walletActions.topupDeduct' },
        { value: 'withdraw_apply', labelKey: 'walletActions.withdrawApply' },
        { value: 'withdraw_reject_refund', labelKey: 'walletActions.withdrawRejectRefund' },
        { value: 'withdraw_fail_refund', labelKey: 'walletActions.withdrawFailRefund' },
        { value: 'withdraw_rollback_refund', labelKey: 'walletActions.withdrawRollbackRefund' },
        { value: 'settlement_income', labelKey: 'walletActions.settlementIncome' }
      ]
    };
  },
  computed: {
    tableLanguage() {
      return this.$i18nState.language;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    labelFor(items, value) {
      this.tableLanguage;
      const item = items.find(one => one.value === value);
      return item ? this.$t(item.labelKey) : (value || '-');
    },
    walletTypeText(value) {
      return this.labelFor(this.walletTypes, value);
    },
    businessTypeText(value) {
      return this.labelFor(this.businessTypes, value);
    },
    actionText(value) {
      return this.labelFor(this.actions, value);
    },
    amountClass(value) {
      if (Number(value) > 0) return 'amount-positive';
      if (Number(value) < 0) return 'amount-negative';
      return '';
    },
    buildQueryParams() {
      return Object.keys(this.search).reduce((params, key) => {
        const value = this.search[key];
        if (value !== '' && value !== null && value !== undefined) params[key] = value;
        return params;
      }, {});
    },
    reload() {
      this.search.page = 1;
      this.loadData();
    },
    async loadData() {
      const resp = await this.$axios.get('/admin/exagent/console/funds/wallet-records/', {
        params: this.buildQueryParams()
      });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.tableData = data.list || [];
      this.count = data.count || 0;
    }
  }
};
</script>

<style scoped>
.filter-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.filter-item { width: 175px; }
.filter-item.short { width: 105px; }
.amount-positive { color: #67c23a; font-weight: 600; }
.amount-negative { color: #f56c6c; font-weight: 600; }
</style>



// WEBPACK FOOTER //
// src/views/WalletRecords.vue